import ClassNames from 'classnames'
import * as React from 'react'
import styled from 'styled-components'
import * as constants from '../../static/constants'
import * as forms from '../../utils/form'

interface IProps {
  label: string
  name: string
}

export const ReviewStarInput: React.FC<IProps> = props => {
  const [score, setScore] = React.useState(0)
  const starsRef = React.useRef(null)
  return (
    <Star>
      <h3>{props.label}</h3>
      <input
        required={true}
        readOnly={true}
        type="text"
        name={props.name}
        defaultValue={score}
        ref={starsRef}
      />
      <div className="Stars_Wrapper">
        {[1, 2, 3, 4, 5].map(value => (
          <span
            key={value}
            onClick={() => {
              forms.setNativeValue(starsRef.current, value, false)
              starsRef.current.dispatchEvent(new Event('input', { bubbles: true }))
              setScore(value)
            }}
          >
            <svg
              className={ClassNames('Stars_Star', {
                filled: value <= score,
              })}
              viewBox="0 0 64 64"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
            >
              <polygon
                fillRule="nonzero"
                points="32.5 45.9878947 48.877 56 44.531 37.13 59 24.4336842 39.9465 22.7963158 32.5 5 25.0535 22.7963158 6 24.4336842 20.469 37.13 16.123 56"
              />
            </svg>
          </span>
        ))}
      </div>
    </Star>
  )
}
const Star = styled.div`
  margin-top: 4px;

  > input {
    display: none;
  }

  .Stars_Wrapper {
    display: flex;

    > span {
      cursor: pointer;
    }
  }

  .Stars_Star {
    width: 32px;
    height: auto;
    fill: none;

    > polygon {
      stroke: ${constants.COLORS.subText};
      stroke-width: 2px;
    }

    &.filled {
      stroke: none;
      fill: ${constants.COLORS.useally};

      > polygon {
        stroke: none;
      }
    }
  }
`
